export default "/assets/images/technology-graph-03.jpg?e9515c9e771089fe7dc89a957d93feb5";